
export class CategoryMode {
    static readonly SHOW_PRODUCTS = 1;
    static readonly SHOW_CATEGORY = 2;
    static readonly SHOW_PRODUCTS_AND_CATEGORY = 3;
    static readonly USE_AS_LEAF = 4;
}
